"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var common_1 = require("stremio/common");
var normalizeLanguage = function (language) {
    var _a, _b;
    if (!language) {
        return undefined;
    }
    var value = language.trim();
    return (_b = ((_a = common_1.languages.find(value)) !== null && _a !== void 0 ? _a : common_1.languages.find(value.toLowerCase()))) === null || _b === void 0 ? void 0 : _b.code;
};
var findPreferredTrack = function (tracks, selectedId, savedTrack, globalLanguage) {
    var preferredLanguage = normalizeLanguage(savedTrack === null || savedTrack === void 0 ? void 0 : savedTrack.language);
    var saved = tracks.find(function (track) { return track.id === (savedTrack === null || savedTrack === void 0 ? void 0 : savedTrack.id); });
    if (saved && (!preferredLanguage || normalizeLanguage(saved.lang) === preferredLanguage)) {
        return saved;
    }
    var selected = tracks.find(function (track) { return track.id === selectedId; });
    var languageOrder = [preferredLanguage, normalizeLanguage(globalLanguage)];
    var _loop_1 = function (language) {
        if (!language) {
            return "continue";
        }
        var track = selected && normalizeLanguage(selected.lang) === language ?
            selected
            :
                tracks.find(function (track) { return normalizeLanguage(track.lang) === language; });
        if (track) {
            return { value: track };
        }
    };
    for (var _i = 0, languageOrder_1 = languageOrder; _i < languageOrder_1.length; _i++) {
        var language = languageOrder_1[_i];
        var state_1 = _loop_1(language);
        if (typeof state_1 === "object")
            return state_1.value;
    }
    return undefined;
};
var useAudio = function (_a) {
    var player = _a.player, video = _a.video, settings = _a.settings, streamStateChanged = _a.streamStateChanged;
    var videoRef = (0, react_1.useRef)(video);
    var trackSelectionLocked = (0, react_1.useRef)(false);
    var appliedTrack = (0, react_1.useRef)(null);
    videoRef.current = video;
    var selectTrack = (0, react_1.useCallback)(function (id) {
        var currentVideo = videoRef.current;
        var track = currentVideo.state.audioTracks.find(function (track) { return track.id === id; });
        if (!track) {
            return;
        }
        var language = normalizeLanguage(track.lang);
        trackSelectionLocked.current = true;
        appliedTrack.current = id;
        currentVideo.setAudioTrack(id);
        streamStateChanged({ audioTrack: __assign({ id: id }, (language ? { language: language } : {})) });
    }, [streamStateChanged]);
    (0, react_1.useEffect)(function () {
        trackSelectionLocked.current = false;
        appliedTrack.current = null;
    }, [video.state.stream]);
    (0, react_1.useEffect)(function () {
        var _a;
        if (trackSelectionLocked.current || video.state.stream === null) {
            return;
        }
        var track = findPreferredTrack(video.state.audioTracks, video.state.selectedAudioTrackId, (_a = player.streamState) === null || _a === void 0 ? void 0 : _a.audioTrack, settings.audioLanguage);
        if (!track) {
            appliedTrack.current = null;
            return;
        }
        if (appliedTrack.current === track.id) {
            return;
        }
        videoRef.current.setAudioTrack(track.id);
        appliedTrack.current = track.id;
    }, [
        player.streamState,
        settings.audioLanguage,
        video.state.audioTracks,
        video.state.selectedAudioTrackId,
        video.state.stream,
    ]);
    return selectTrack;
};
exports.default = useAudio;
